import { render, staticRenderFns } from "./addgoodssalereturn.vue?vue&type=template&id=58e83518&scoped=true&"
import script from "./addgoodssalereturn.vue?vue&type=script&lang=js&"
export * from "./addgoodssalereturn.vue?vue&type=script&lang=js&"
import style0 from "./addgoodssalereturn.vue?vue&type=style&index=0&id=58e83518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e83518",
  null
  
)

export default component.exports